var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i-table',{attrs:{"border":"","columns":_vm.columns,"data":_vm.content},on:{"on-selection-change":_vm.selectionDataChanged}})}
var staticRenderFns = []

export { render, staticRenderFns }